import React, { useState, useEffect, useMemo, useCallback } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import Select from "react-select"
import redirectURL from "../redirectURL"
import { Modal } from "react-responsive-modal";
import 'react-responsive-modal/styles.css';
import "../../assets/css/inventorymanagement.css"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaInfoCircle } from "react-icons/fa";
import "./datepicker.css"


const todayIST = () =>
  new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });

const WarehouseDemandDistributionDashboard = () => {
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n");
  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");
  const [rowData, setRowData] = useState([]);

  // Slider state for Create Demand
  const [isSliderOpen, setSliderOpen] = useState(false);
  const [sliderType, setSliderType] = useState(null);
  const [sliderCl, setSliderCl] = useState("");
  const [sliderTitle, setSliderTitle] = useState("");
  const [createDemandDate, setCreateDemandDate] = useState(() => todayIST());
  const [isCreatingDemand, setIsCreatingDemand] = useState(false);

  const [currentDate, setCurrentDate] = useState("");
  const [warehouse, setWarehouse] = useState(null);
  const [skuCode, setSkuCode] = useState(null);
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [skuOptions, setSkuOptions] = useState([]);
  const [highlightedDates, setHighlightedDates] = useState([]);

  
  const [latestSafetyDate, setLatestSafetyDate] = useState(todayIST())

  // CustomHeader component

      const getHighlightedDates = async () => {  
      try {
        const response = await redirectURL.post("indentation/getWHDDdates", {});
        if (response.status === 200 && response.data.dates) {
          const dates = response.data.dates.map(dateStr => {
            try {
              return new Date(dateStr);
            } catch (e) {
              return null;
            }
          }).filter(date => date !== null);
          setHighlightedDates(dates);
        }
      } catch (error) {
        console.error("Failed to fetch highlighted dates:", error);
      }
    }
  const CustomHeader = (props) => {
    const tooltip = props?.column?.getColDef()?.headerTooltip || "";
    const [showMenu, setShowMenu] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);

    const onMenuClick = (event) => {
      props.showColumnMenu(event.currentTarget);
    };

    const onSortRequested = (order, event) => {
      props.setSort(order, event?.shiftKey);
    };

    const getSort = () => {
      return props.column.getSort();
    };

    const isSortable = props.column.getColDef().sortable;

    return (
      <div
        style={{ display: "flex", alignItems: "center", gap: 6, position: "relative" }}
        onMouseEnter={() => setShowMenu(true)}
        onMouseLeave={() => setShowMenu(false)}
      >
        <span
          style={{
            cursor: isSortable ? "pointer" : "default",
            userSelect: "none"
          }}
          onClick={isSortable ? () => {
            const currentSort = getSort();
            let newSort = 'asc';
            if (currentSort === 'asc') newSort = 'desc';
            else if (currentSort === 'desc') newSort = null;
            onSortRequested(newSort, null);
          } : undefined}
        >
          {props.displayName}
        </span>

        {isSortable && (
          <div style={{ display: "flex", flexDirection: "column", marginRight: 2 }}>
            <span
              style={{
                cursor: "pointer",
                fontSize: 10,
                opacity: getSort() === 'asc' ? 1 : 0.3,
                lineHeight: "8px"
              }}
              onClick={() => onSortRequested('asc', null)}
            >
              ↑
            </span>
            <span
              style={{
                cursor: "pointer",
                fontSize: 10,
                opacity: getSort() === 'desc' ? 1 : 0.3,
                lineHeight: "8px"
              }}
              onClick={() => onSortRequested('desc', null)}
            >
              ↓
            </span>
          </div>
        )}

        <div
          style={{ position: "relative", display: "inline-block" }}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <FaInfoCircle style={{ fontSize: 18, opacity: 0.7 }} />

          {showTooltip && tooltip && (
            <div
              style={{
                position: "absolute",
                top: "100%",
                left: "50%",
                transform: "translateX(-50%)",
                backgroundColor: "rgba(0, 0, 0, 0.8)",
                color: "white",
                padding: "8px 12px",
                borderRadius: "4px",
                fontSize: "12px",
                whiteSpace: "nowrap",
                zIndex: 1000,
                marginTop: "5px",
              }}
            >
              {tooltip}
            </div>
          )}
        </div>

        {props.enableMenu && (
          <span
            onClick={onMenuClick}
            style={{
              marginLeft: "5px",
              cursor: "pointer",
              fontSize: 14,
              opacity: showMenu ? 1 : 0,
              transition: "opacity 0.2s ease",
            }}
          >
            ☰
          </span>
        )}
      </div>
    );
  };

  const columnDefs = [
    { headerName: "Destination Store ID", field: "destination_store_id" },
    { headerName: "Destination Store Name", field: "destination_store_name" },
    { headerName: "Destination Type", field: "destination_type" },
    { headerName: "Source Name", field: "source_name" },
    { headerName: "Source ID", field: "source_id" },
    { headerName: "SKU Code", field: "sku_code" },
    { headerName: "SKU Name", field: "sku_name" },
    { headerName: "SKU Category", field: "sku_category" },
    {
      headerName: "Cycle Date",
      valueGetter: params => params.data.cycle_date ? new Date(params.data.cycle_date).toLocaleDateString() : ""
    },
    { headerName: "Current Stock", field: "current_stock" },
    { headerName: "Business Day Run Rate", field: "business_day_run_rate" },
    { headerName: "Wholesale Day Run Rate", field: "wholesale_day_run_rate" },
    { headerName: "Safety Stock", field: "safety_stock" },
    { headerName: "Reorder Point Stock", field: "reorder_point_stock" },
    {
      headerName: "ROP Fulfillment Stock", 
      field: "rop_fulfillment_stock",
    },
    { headerName: "Transit Days", field: "transit_days" },
    { headerName: "Packaging Time", field: "packaging_time" },
    { headerName: "Production Cycle Time", field: "production_cycle_time" },
    { headerName: "QC Hold Days", field: "qc_hold_days" },
    { headerName: "Replenishment Cycle Time", field: "replenishment_cycle_time" },
    { headerName: "Plant Current Stock", field: "plant_current_stock" },
    {
      headerName: "Demand", 
      field: "demand",
    },
    {
      headerName: "Demand Proportionality", 
      field: "demand_proportionality",
    },
    { headerName: "Plant Threshold", field: "plant_threshold" },
    {
      headerName: "Plant Excess Stock", 
      field: "plant_excess_stock",
    },
    {
      headerName: "Fair Share Flag", 
      field: "fair_share_flag",
    },
    { headerName: "Indent Stock", field: "indent_stock" },
  ];

  const sideBar = useMemo(() => ({
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ]
  }), []);

  const statusPanel = {
    statusPanels: [
      {
        statusPanel: "agTotalAndFilteredRowCountComponent",
        align: "left"
      },
      {
        statusPanel: "agTotalRowCountComponent",
        align: "center"
      },
      { statusPanel: "agFilteredRowCountComponent" },
      { statusPanel: "agSelectedRowCountComponent" },
      { statusPanel: "agAggregationComponent" }
    ]
  }

  const defaultColDef = {
    sortable: true,
    filter: true,
    pivot: true,
    enableValue: true,
    enableRowGroup: true,
    resizable: true,
  }

  const getWDData = async () => {
    try {
      const response = await redirectURL.post("indentation/getWDData", {});

      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          const { date, warehouses, skus, data, latest_safety_date } = response.data;

          const formattedDate = date ? new Date(date).toISOString().split('T')[0] : '';
          const latestSafetyDate = latest_safety_date ? new Date(latest_safety_date).toISOString().split('T')[0] : '';

          const warehouseOptions = warehouses.map(w => ({ value: w, label: w }));
          warehouseOptions.unshift({ label: "ALL", value: "" });

          const skuOptions = skus.map(sku => ({ value: sku, label: sku }));
          skuOptions.unshift({ label: "ALL", value: "" });
          
          setLatestSafetyDate(latestSafetyDate);
          setCreateDemandDate(latestSafetyDate);
          setWarehouseOptions(warehouseOptions);
          setSkuOptions(skuOptions);
          setWarehouse(warehouseOptions[0]);
          setSkuCode(skuOptions[0]);
          setRowData(data);
          setCurrentDate(formattedDate);
          await getHighlightedDates();
        } else {
          setLoadshow("show-n");
          setOverlayBlock("show-n");
        }
      }
    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setBasicTitle("Failed to fetch data");
      setBasicType("error");
      setShow(true);
    }
  }

  const getMainData = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    await getWDData();
    setLoadshow("show-n");
    setOverlayBlock("show-n");
  }

  const triggerUserAction = (trigerdata) => {
    redirectURL.post('inventory/triggerUserAction', trigerdata);
  }

  const getWDSkuOption = async () => {
    try {
      const query = {};

      if (warehouse && warehouse.value) {
        query.warehouse = warehouse.value;
      }

      if (currentDate) {
        query. date = currentDate;
      }

      const response = await redirectURL.post("indentation/getWDSkuOption", query);

      if (response.status === 200) {
        const { data } = response.data;
        const skuOptions = data.map(sku => ({ label: sku, value: sku }));
        skuOptions.unshift({ label: "ALL", value: "" });
        setSkuOptions(skuOptions);
        setSkuCode(skuOptions[0]);
      }
    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setBasicTitle("Failed to fetch SKU data");
      setBasicType("error");
      setShow(true);
    }
  }

  const getWDWarehouseOptions = async () => {
    try {
      const query = {};

      if (currentDate) {
        query. date = currentDate;
      }

      const response = await redirectURL.post("indentation/getWDWarehouseOptions", query);

      if (response.status === 200) {
        const { warehouses } = response.data;
        const warehouseOptions = warehouses.map(w => ({ value: w, label: w }));
        warehouseOptions.unshift({ label: "ALL", value: "" });
        setWarehouseOptions(warehouseOptions);
        setWarehouse(warehouseOptions[0]);
      }
    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setBasicTitle("Failed to fetch warehouse data");
      setBasicType("error");
      setShow(true);
    }
  }

  const getWDDataByFilter = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");

    const params = {
      date: currentDate,
    };

    if (warehouse && warehouse.value) {
      params.warehouse = warehouse.value;
    }

    if (skuCode && skuCode.value) {
      params.sku_code = skuCode.value;
    }

    try {
      const response = await redirectURL.post(
        "indentation/getWDDataByFilter",
        params
      );
      const data = response.data.data;
      setRowData(data);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicType("info");
      setBasicTitle("Error Failed to get Warehouse Demand Distribution Data");
    }
  };

  const setFilters = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    await getWDDataByFilter();
    setLoadshow("show-n");
    setOverlayBlock("show-n");
  }

  const resetFilters = async () => {
    setWarehouse(warehouseOptions[0]);
    setSkuCode(skuOptions[0]);
    await getMainData();
  }

  useEffect(() => {
    getMainData();
  }, []);

  useEffect(() => {
    if (currentDate) {
      getWDWarehouseOptions();
    }
  }, [currentDate]);

  useEffect(() => {
    if (currentDate && warehouse) {
      getWDSkuOption();
    }
  }, [warehouse, currentDate]);

  const closeAlert = () => {
    setShow(false);
  };

  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
    setSliderOpen(false);
    setCreateDemandDate(latestSafetyDate);
  };

  const onClickingSliderCloseIcon = () => {
    setOverlyBlock("show-n");
    setSliderOpen(false);
    setCreateDemandDate(latestSafetyDate);
  };

  const openCreateDemandSlider = () => {
    setSliderType(1);
    setSliderTitle("Create Warehouse Demand");
    setSliderCl("create-demand-slider");
    setOverlyBlock("show-m");
    setSliderOpen(true);
  };

 const onSaveCreateDemand = async (e) => {
  e.preventDefault();
  if (!createDemandDate) {
    setShow(true);
    setBasicType("info");
    setBasicTitle("Please select a date");
    return;
  }

  try {
    setIsCreatingDemand(true);
    setLoadshow("show-m");
    setOverlayBlock("show-m");

    const response = await redirectURL.post(
      "indentation/onTriggerWarehouseDemandDistribution",
      { trigger_date: createDemandDate }
    );

    const res = response?.data?.pyResponse;

    if (res?.status === "Success") {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicType("success");
      setBasicTitle(res.message);
      setSliderOpen(false);
      setOverlyBlock("show-n");
      setCreateDemandDate(latestSafetyDate);
      
      const userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Trigger Warehouse Demand Distribution",
        status: res.status,
        path: window.location.pathname
      };
      triggerUserAction(userData);

      // Refresh the data after successful demand creation
      await getMainData();
    } 
    else {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicType("info");
      setBasicTitle(res?.message || "Failed to trigger warehouse demand creation");

      // Optional audit for failures (enable if required)
      /*
      triggerUserAction({
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Trigger Warehouse Demand Distribution",
        status: res?.status || "Failure",
        path: window.location.pathname
      });
      */
    }

  } catch (error) {
    console.error("Error triggering warehouse demand:", error);
    setLoadshow("show-n");
    setOverlayBlock("show-n");
    setShow(true);
    setBasicType("error");
    setBasicTitle(
      error?.response?.data?.message || "Failed to trigger warehouse demand creation. Please try again later."
    );
    
    const userData = {
      email: localStorage.getItem("email"),
      user_code: localStorage.getItem("user_code"),
      action: "Trigger Warehouse Demand Distribution",
      status: "Failed",
      path: window.location.pathname
    };
    triggerUserAction(userData);
  } finally {
    setIsCreatingDemand(false);
  }
};

  return (
    <>
      <div className="container-fluid mt-3">
        <div style={{ zIndex: "9999999" }}>
          <SweetAlert
            show={show}
            type={basicType}
            title={basicTitle}
            onConfirm={closeAlert}
            style={{ fontSize: "9px" }}
          >
          </SweetAlert>
        </div>

        <div className="row" style={{ fontSize: "0.9rem", fontFamily: "Arial, sans-serif" }}>
          <form className="col-sm-12 p-0 mt-2 mb-4" style={{ display: "flex", alignItems: "center" }}>
            <div className="col-sm-12 row ">
              <div className="col-sm-2 mb-1" style={{ display: "flex", flexDirection: "column" }}>
                <label style={{ fontSize: "13px", fontWeight: "400" }}>
                  Date:
                </label>
                {/* <input
                  type="date"
                  id="invoiceDate"
                  value={currentDate}
                  onChange={(e) => setCurrentDate(e.target.value)}
                  style={{ padding: "7px", borderRadius: "5px", border: "1px solid #d9d9d9", width: "100%", marginBottom: "15px", cursor: "pointer" }}
                  onClick={() => document.getElementById('invoiceDate').showPicker?.()} /> */}
                  <DatePicker
  selected={currentDate ? new Date(currentDate) : null}
  onChange={(date) => setCurrentDate(date ? date.toISOString().split('T')[0] : '')}
  dateFormat="yyyy-MM-dd"
  className="form-control"
  placeholderText="Select Date"
  highlightDates={highlightedDates}
  style={{ 
    padding: "7px", 
    borderRadius: "5px", 
    border: "1px solid #d9d9d9", 
    width: "100%", 
    marginBottom: "15px", 
    cursor: "pointer" 
  }}
/>
              </div>

              <div className="col-sm-2 mb-1" style={{ display: 'flex', flexDirection: 'column' }}>
                <label htmlFor="warehouse" style={{ fontSize: '13px', fontWeight: '400' }}>
                  Warehouse:
                </label>
                <Select
                  id="warehouse"
                  value={warehouse}
                  onChange={setWarehouse}
                  options={warehouseOptions}
                  styles={selectStyles}
                />
              </div>

              <div className="col-sm-2 mb-1" style={{ display: 'flex', flexDirection: 'column' }}>
                <label htmlFor="skuCode" style={{ fontSize: '13px', fontWeight: '400' }}>
                  SKU Code:
                </label>
                <Select
                  id="skuCode"
                  value={skuCode}
                  onChange={setSkuCode}
                  options={skuOptions}
                  styles={selectStyles}
                />
              </div>

              <div className="ml-4 mt-4" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "0px 10px" }}>
                <button
                  type="button"
                  onClick={setFilters}
                  style={{
                    backgroundColor: "#93385D",
                    color: "#fff",
                    borderRadius: "5px",
                    padding: "8px 20px",
                    border: "none",
                    cursor: "pointer"
                  }}
                >
                  Apply
                </button>
                <button
                  onClick={resetFilters}
                  type="button"
                  style={{
                    backgroundColor: "#fff",
                    color: "#000",
                    borderRadius: "5px",
                    padding: "8px 20px",
                    border: "1px solid #d9d9d9",
                    cursor: "pointer"
                  }}
                >
                  Reset
                </button>
              </div>

              <div className="mt-4" style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
                <button
                  type="button"
                  onClick={openCreateDemandSlider}
                  style={{
                    backgroundColor: "#93385D",
                    color: "#fff",
                    borderRadius: "5px",
                    height: "36px",
                    padding: "0 20px",
                    border: "none",
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center"
                  }}
                >
                  Trigger Demand Distribution
                </button>
              </div>
            </div>
          </form>

          <div className="col-sm-12 p-0 pl-2">
            <div className="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
              <AgGridReact
                rowData={rowData}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                domLayout="normal"
                sideBar={sideBar}
                statusBar={statusPanel}
                pagination={true}
                paginationPageSize={100}
                enableRangeSelection={true}
                gridOptions={{
                  suppressHorizontalScroll: false
                }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Slider for Create Warehouse Demand */}
      <div
        className={`stock-status-slider ${isSliderOpen ? "open" : ""} ${sliderCl}`}
        style={{ width: "25%" }}
      >
        <div className="slider-header-container d-flex justify-content-between">
          <p className="m-0p">{sliderTitle}</p>
          <p
            className="m-0p"
            style={{ cursor: "pointer" }}
            onClick={onClickingSliderCloseIcon}
          >
            X&nbsp;&nbsp;&nbsp;
          </p>
        </div>
        {sliderType === 1 && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              overflowY: "auto",
              padding: 5,
            }}
          >
            <form
              style={{ flexGrow: 1, overflowY: "auto", padding: "10px" }}
              onSubmit={onSaveCreateDemand}
            >
              <div className="mb-1" style={{ display: "flex", flexDirection: "column" }}>
                <label
                  htmlFor="createDemandDate"
                  style={{ fontSize: "13px", fontWeight: "400", cursor: "pointer" }}
                >
                  Date:
                </label>
                <input
                  type="date"
                  id="createDemandDate"
                  value={createDemandDate}
                  onChange={(e) => setCreateDemandDate(e.target.value)}
                  min="2025-09-01"
                  max={latestSafetyDate}
                  style={{
                    padding: "7px",
                    borderRadius: "5px",
                    border: "1px solid #d9d9d9",
                    width: "100%",
                    marginBottom: "15px",
                    cursor: "pointer",
                  }}
                  onClick={() => document.getElementById("createDemandDate").showPicker?.()}
                  required
                />
              </div>

              <div style={{ textAlign: "right", marginTop: "10px" }}>
                <button
                  className="btn"
                  style={{
                    backgroundColor: "#93385D",
                    color: "#fff",
                    fontSize: "0.8rem",
                  }}
                  type="submit"
                  disabled={isCreatingDemand}
                >
                  {isCreatingDemand ? "Getting Data..." : "Trigger Demand Distribution"}
                </button>
              </div>
            </form>
          </div>
        )}
      </div>

      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
      <div className={`overlay-block ${overlayBlock}`}></div>
      <div
        className={"overly-block " + overlyBlock}
        onClick={hideOverlySlideBlock}
      ></div>
    </>
  );
};

const selectStyles = {
  control: (base) => ({
    ...base,
    padding: '1px',
    borderRadius: '5px',
    border: '1px solid #d9d9d9',
  }),
  singleValue: (base) => ({
    ...base,
    fontWeight: 'normal',
    color: '#333',
    fontSize: '12px'
  }),
  option: (base, state) => ({
    ...base,
    fontSize: '13px',
    fontWeight: state.isSelected ? 'normal' : 'normal',
  })
};

export default WarehouseDemandDistributionDashboard;